module.exports = __webpack_public_path__ + "static/media/Chardan-10.0f2658a3.svg";